import React, { useContext } from "react";
import { Context } from "../store/appContext";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "../styles/layout.css";

const Home = () => {
  const { store } = useContext(Context);

  return (
    <>
      <div className="home-hero">
        <div className="home-hero-overlay">
          <div className="container text-center">
            <h1 className="display-4 fw-bold mb-3">Analítica de Inventario</h1>

            <p className="lead mb-4">
              Analítica avanzada para el control y evolución del inventario
              industrial.
            </p>

            {!store.isAuthenticated ? (
              <Link to="/login" className="btn btn-primary btn-lg">
                Iniciar sesión
              </Link>
            ) : (
              <Link to="/panel" className="btn btn-success btn-lg">
                Ir al Panel
              </Link>
            )}
          </div>
        </div>
      </div>

      <section className="py-5 bg-light">
        <div className="container text-center">
          <h3 className="mb-3">Control total del inventario</h3>

          <p className="text-muted">
            Plataforma diseñada para entornos industriales que permite analizar
            el comportamiento del inventario, optimizar el stock y detectar
            tendencias en el consumo de materiales.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
